import { InformationCircleIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';

interface InfoMessageProps {
  message: string;
  /**
   * Keep the banner's own `mt-3 mb-4`.
   *
   * [MCV-1577] An explicit flag rather than a `className` passthrough,
   * because the margins have to be *removed*, not overridden: there is no
   * tailwind-merge here, so a passed `my-0` would win or lose purely on CSS
   * emit order (Tailwind emits `my-*` before `mt-*`/`mb-*`, so it would
   * lose) and the override would look correct while doing nothing.
   *
   * Every parent this banner currently sits in — `FormLayout` and the wizard
   * body — spaces its children with `gap-5`, and a margin *adds* to a flex
   * gap instead of collapsing into it the way it did in the old block flow,
   * so those call sites pass `false` and let the parent own the rhythm. The
   * default stays on so a consumer that renders the banner outside a
   * gap-owning parent keeps the spacing it has today.
   */
  withOwnMargin?: boolean;
}

export const InfoMessage = ({ message, withOwnMargin = true }: InfoMessageProps) => {
  return (
    <div
      className={classNames('w-full bg-primary-t-900 p-4 rounded-lg', {
        'mb-4 mt-3': withOwnMargin,
      })}
    >
      <div className="flex items-center">
        <InformationCircleIcon className="h-5 w-5 text-primary-t-50 stroke-2 mr-3" />
        <p className="body-text-sb">{message}</p>
      </div>
    </div>
  );
};
